<template >
    <div class="popup-container">
        <div class="text-justify popup-wrapper">
            <div class="popup-header">
                <span>Alert</span> <i class="fa fa-times close-icon" @click="closePopup"></i>
            </div>
            <div class="popup-body">
                <p> We noticed you have changed your brokerage. In the past you were registered with <b style="font-weight:600;">{{office.old}}</b>,
                     but your latest MLS credentials shows that you are now with <b style="font-weight:600;">{{office.new}}</b>. <br>
                Click "Move" to move your account to your new brokerage. </p>
            </div>
            <div class="popup-footer">
                <button class="ob-button" style = "alignItems:center;float:right;width:130px;min-width:130px;" @click = "moveBrokerage">Move</button>
                <button class="ob-button" style = "alignItems:center;float:right;width:130px;min-width:130px;margin-right:20px;" @click = "closePopup">No I'm Ok</button>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    methods:{
        closePopup(){
            this.$emit('closePopup')
        },
        moveBrokerage(){
            this.$emit('moveBrokerage')
        }
    },
    props : ['office'],
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        },
        orgEmail(){
            let title = this.$store.state.orgTitle
            return "support@" + title + ".com"
        },
        mailHref(){
            let title = this.$store.state.orgTitle
            return "mailto:support@" + title + ".com"
        }
    }
}
</script>

<style lang="scss" >
.terms-text{
    overflow-y: auto;
    max-height: calc(100vh - 300px);
}
</style>
